export { GojsDiagramExtension } from './gojs-diagram.extension';
export { GOJS_DIAGRAM_NODE_NAME } from './gojs-diagram.model';
